"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactModal = _interopRequireDefault(require("react-modal"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _dialogModule = _interopRequireDefault(require("./dialog.module.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Dialog = function Dialog(_ref) {
  var active = _ref.active,
      aria = _ref.aria,
      className = _ref.className,
      overlayClassName = _ref.overlayClassName,
      onClose = _ref.onClose,
      children = _ref.children,
      modalOptions = _ref.modalOptions;
  return /*#__PURE__*/_react["default"].createElement(_reactModal["default"], _extends({
    isOpen: active,
    ariaHideApp: false,
    shouldCloseOnOverlayClick: false,
    onRequestClose: onClose,
    aria: aria,
    className: (0, _classnames["default"])(_dialogModule["default"].dialog, 'bg-white flex flex-col overflow-hidden rounded outline-none scrolling-touch shadow-xl', className),
    overlayClassName: (0, _classnames["default"])(_dialogModule["default"].overlay, 'fixed top-0 right-0 bottom-0 left-0 flex justify-center items-center z-30', overlayClassName)
  }, modalOptions), children);
};

Dialog.propTypes = {
  active: _propTypes["default"].bool,
  children: _propTypes["default"].node,
  className: _propTypes["default"].string,
  overlayClassName: _propTypes["default"].string,
  onClose: _propTypes["default"].func,
  aria: _propTypes["default"].shape({
    labelledby: _propTypes["default"].string,
    describedby: _propTypes["default"].string
  }),
  modalOptions: _propTypes["default"].shape({})
};

var noop = function noop() {};

Dialog.defaultProps = {
  aria: {},
  active: false,
  children: null,
  className: '',
  overlayClassName: '',
  onClose: noop,
  modalOptions: {}
};

var Header = function Header(_ref2) {
  var id = _ref2.id,
      className = _ref2.className,
      title = _ref2.title;
  return /*#__PURE__*/_react["default"].createElement("div", {
    id: id,
    className: (0, _classnames["default"])('relative flex flex-col justify-center p-2 border-b-2 border-primary text-primary text-xl font-bold', className)
  }, title);
};

Header.propTypes = {
  id: _propTypes["default"].string,
  className: _propTypes["default"].string,
  title: _propTypes["default"].node
};
Header.defaultProps = {
  id: null,
  className: '',
  title: null
};

var Body = function Body(_ref3) {
  var className = _ref3.className,
      children = _ref3.children;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('p-5 overflow-y-auto', className)
  }, children);
};

Body.propTypes = {
  className: _propTypes["default"].string,
  children: _propTypes["default"].node
};
Body.defaultProps = {
  className: '',
  children: null
};

var Footer = function Footer(_ref4) {
  var className = _ref4.className,
      children = _ref4.children;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('flex justify-end p-2 border-t border-primary', className)
  }, children);
};

Footer.propTypes = {
  className: _propTypes["default"].string,
  children: _propTypes["default"].node
};
Footer.defaultProps = {
  className: '',
  children: null
};
Dialog.Header = Header;
Dialog.Body = Body;
Dialog.Footer = Footer;
var _default = Dialog;
exports["default"] = _default;